import * as React from 'react';
import { 
    Bar, 
    Disc20mm, 
    Disc30mm, 
    REnd, 
    Shield, 
    Star20mm, 
    Star30mm,
    RCnr
} from '../Badges';
import { BadgeImageProps } from './BadgeImage.types';
import { BadgeStyles } from '../../utils/interfaces';
import './styles/BadgeImage.css';
import { Finish } from '../TitleBadge/TitleBadge.types';

const badgeType = (
  style: BadgeStyles,
  finish: Finish,
  isMetal: boolean,
  shineAssets: Record<string, string>
) => {
  switch(style) {
    case BadgeStyles.Bar:
      return <Bar finish={finish} shineAsset={shineAssets.bar} />;
      break;
    case BadgeStyles.Disc20mm:
      return <Disc20mm finish={finish} shineAsset={shineAssets.disc} />;
      break;
    case BadgeStyles.Disc30mm:
      return <Disc30mm finish={finish} shineAsset={shineAssets.disc} />;
      break;
    case BadgeStyles.REnd:
      return <REnd finish={finish} shineAsset={shineAssets.rEnd} />;
      break;
    case BadgeStyles.Star20mm:
      return <Star20mm finish={finish} />;
      break;
    case BadgeStyles.Star30mm:
      return <Star30mm finish={finish} />;
      break;
    case BadgeStyles.RCnr:
      return <RCnr finish={finish} />;
      break;
    default:
      return <Shield finish={finish} isMetal={isMetal} shineAsset={shineAssets.shield} />;
  }
};

export const BadgeImage = ({
    style,
    color,
    title,
    finish,
    shineAssets,
}: BadgeImageProps) => {
  const finishStops: any = {
    [Finish.Gold]: {
      dark: "#8C6C11",
      light: "#CEA027",
    },
    [Finish.Bronze]: {
      dark: "#8B634B",
      light: "#a17458",
    },
    [Finish.Silver]: {
      dark: "#848484",
      light: "#cdcccc",
    }
  };
  const isMetal = color.includes('Metal');
  return (
    <>
      <div
        className="badge-image large"
        data-color={color}
        data-style={style}
      >
        <div className={`image-title ${isMetal ? 'black' : finish.toLowerCase()}`}>
          <span>{title}</span>
        </div>
        {badgeType(style, finishStops[finish], isMetal, shineAssets)}
      </div>
    </>
  );
};
